/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Notes_IncompleteInputs */



/**
* | output |
* | --- |
* | "Event has notes marked as incomplete." |
*
* @param {Error_Nav_Notes_IncompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_notes_incomplete = /** @type {((inputs?: Error_Nav_Notes_IncompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Notes_IncompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'evenement a des notes marquees comme incompletes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisnotizen sind als unvollständig gekennzeichnet.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'evento ha note contrassegnate come incomplete.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В описании мероприятия есть пометки, отмеченные как неполные.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento tiene notas marcadas como incompletas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动记录标记为不完整。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントには未完了としてマークされたメモがあります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस इवेंट के नोट्स अधूरे के रूप में चिह्नित हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento possui anotações marcadas como incompletas.")
	return /** @type {LocalizedString} */ ("Event has notes marked as incomplete.")
});